module.exports = __webpack_public_path__ + "img/museumscard-2020.e808a9e1.png";